import Route from '@ember/routing/route';
import { hash } from 'rsvp';
import { inject as service } from '@ember/service';
import BuyerOnlyRouteMixin from 'sh-www/mixins/buyer-only-route-mixin';
import { ASSIGNMENT } from 'sh-www/models/assignment';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectCreateDirectRoute extends Route.extend(BuyerOnlyRouteMixin) {
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;

  @service api;
  @service session;
  @service store;

  /**
   * @inheritDoc
   */
  model(params) {
    this.stateManager.initStateManager();
    this.stateManager.setPostingType(ASSIGNMENT.TYPES.STANDARD);
    this.stateManager.setCreatedFrom(ASSIGNMENT.CREATED_FROM.DIRECT);
    this.stateManager.setSelect(false);
    this.stateManager.updateForDirectHire(params.freelancerId);

    const companyId = this.session.currentUser.company.id;

    return hash({
      companyMemberships: this.stateManager.loadCompanyWithMembers(companyId),
      companyTeams: this.stateManager.loadCompanyTeams(companyId),
      company: this.stateManager.loadCompany(),
      countries: this.stateManager.loadCountries(),
      freelancerUser: this.stateManager.loadFreelancer(),
      services: this.stateManager.loadServices(),
      productions: this.getProductions(companyId),
    });
  }

  /**
   * @inheritDoc
   */
   activate(transition) {
    super.activate(...arguments);
    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', true);
    trackPageViewFromTransition(this, transition, '/project/create/:freelancerId/');
  }

  /**
   * @inheritDoc
   */
  deactivate() {
    super.deactivate(...arguments);
    const applicationController = this.controllerFor('application');
    applicationController.set('isShowCreatePostingHeader', false);
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('type', null);
    }
  }

  async getProductions(company_id) {
    const params = {
      filter: { company_id },
      count: 50,
    };

    const response = await this.api.get('productions', { params });
    this.store.pushPayload(response);

    return response.data.map(({ id }) =>
      this.store.peekRecord('production', id),
    );
  }
}

export default ProjectCreateDirectRoute;
